/** Central social + contact links for Wisdom Peters */
export const CONTACT_PHONE = "+44 7518 576657";
export const CONTACT_PHONE_E164 = "447518576657";
export const CONTACT_EMAIL = "contact@wisdompeters.com";

export const SOCIAL_LINKS = {
  x: "https://x.com/LightWithin365",
  tiktok: "https://www.tiktok.com/@wisdom.peters2?_t=ZN-8z0PDjEKEQp&_r=1",
  youtube: "https://www.youtube.com/@pastorwisdompeters",
  facebook:
    "https://www.facebook.com/profile.php?id=100063770981845&mibextid=wwXIfr&mibextid=wwXIfr",
  // Matches TikTok handle; update if a different Instagram account is preferred
  instagram: "https://www.instagram.com/wisdom.peters2/",
};

export const WHATSAPP_URL = `https://wa.me/${CONTACT_PHONE_E164}?text=${encodeURIComponent(
  "Hello Wisdom Peters — I’d like to enquire about coaching, speaking, or a book.",
)}`;
